var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDocCodeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 7,
    r: 7,
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 9.3L29.4 7L31.7 4.7L31 4L28 7L31 10L31.7 9.3ZM34.3 9.3L36.6 7L34.3 4.7L35 4L38 7L35 10L34.3 9.3Z",
    fill: "#0033AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H24V26H16V24ZM16 20H24V22H16V20ZM22 10H14C12.9 10 12 10.9 12 12V28C12 29.1 12.89 30 13.99 30H26C27.1 30 28 29.1 28 28V16L22 10ZM26 28H14V12H21V17H26V28Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocCodeCircle);
export default __webpack_public_path__ + "static/media/ic_doc-code_circle.00941d9353a0e234f5cf5b7a0d5cc989.svg";
export { ForwardRef as ReactComponent };